import React from 'react';
import classnames from 'classnames';
import 'assets/stylesheets/modules/_loading-indicator.scss';

interface LoadingIndicatorProps {
  className?: string;
  type?: 'inline';
  inline?: boolean;
  style?: React.CSSProperties;
}

export default class LoadingIndicator extends React.Component<LoadingIndicatorProps> {
  render() {
    return (
      <div
        data-testid='loading-indicator'
        className={classnames('loading-indicator', this.props.className, {
          inline: this.props.type === 'inline' || this.props.inline
        })}
        style={this.props.style ? this.props.style : undefined}
      >
        <div className='loading-indicator__circles-wrapper'>
          <div className='loading-indicator__circle' />
          <div className='loading-indicator__circle' />
          <div className='loading-indicator__circle' />
          <div className='loading-indicator__circle' />
        </div>
      </div>
    );
  }
}
